import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario6SurgeryWardAudioCaching, scenario6SurgeryWardVideoSegments } from "../../../Scenario6-surgery-ward";
import { SurgeryWardComponentsStep0ComponentMainConfig, SurgeryWardComponentsStep0ComponentPart1Config } from "../surgery-ward-components-step0";

export default class SurgeryWardComponentsStep0Part1 extends BaseScenarioPart<GameBaseScenario> {
	private get config(): SurgeryWardComponentsStep0ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: SurgeryWardComponentsStep0ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	private stepName = 'Step 1';

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		let chapter = context.config.chapter;
		context.playVideoChapter(chapter(), () => {
			context.section2();
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario6SurgeryWardAudioCaching.getItemByKey(scenario6SurgeryWardAudioCaching.audioKeys.question1).src,
			subtitle: (this.stepName + ' - Question 1'),
			questionTitle: 'Select the one that best describes the employee\'s action ',
			options: [
				{
					title: 'Human Error',
					description: `
						<ul>
						<li>The employee is not accountable.</li>
						<li>The employee should be consoled.</li>
						<li>The employee should be interviewed and consulted during any systems level analysis.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">Correct. Kelly had followed protocol, she was interrupted multiple times, 
						and was trying to manage a high workload/task load, keep her patient safe by answering call lights, 
						and dealing with the frustration of managing a post-operative patient without the needed orders and 
						poor response times with call backs from the resident. She was working appropriately and, in the 
						patient’s best interest. She did not purposely make choices that led to the error.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'At Risk Behavior',
					description: `
						<ul>
						<li>The employee is accountable and should receive coaching.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Kelly did not consciously make choices with an 
						awareness of risk; she was placed in a situation that increased the chances an error would occur.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Reckless Behavior',
					description: `
						<ul>
						<li>Discipline may be warranted.</li>
						<li>The employee is accountable and should receive re-training/coaching as necessary.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Kelly did not make a risky choice with little to no concern about the risk created.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario6SurgeryWardVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 1 '), parentQuestionConfig, () => {
					this.section3();
				}, () => {
					this.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[0], mentorInfo.chapterIds[1], mentorInfo.chapterIds[2], 'At Risk Behavior');
			}
		}, 0);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			audioUrl: scenario6SurgeryWardAudioCaching.getItemByKey(scenario6SurgeryWardAudioCaching.audioKeys.question2).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the correct answer, what is the appropriate path to take with the employee ',
			options: [
				{
					title: 'Console',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. In Just Culture, employees are to be consoled if their behavior was considered a human error.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Console and coach',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Not the best option. Coaching is needed for employee’s actions that are considered “at-risk behavior.”</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console, coach, and consider discipline',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The employee did not knowingly make an unsafe choice with little or no concern about risk.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario6SurgeryWardVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[3], mentorInfo.chapterIds[4], mentorInfo.chapterIds[5], 'Console and coach');
			}
		}, 1);
	}
}